(()=>{'use strict';
if(window.SDPC)return;
const $=(s,c=document)=>c?.querySelector(s)||null;
const $$=(s,c=document)=>c?Array.from(c.querySelectorAll(s)):[];
const R=window.SochDostRoutes||{};
const esc=v=>String(v||'').replace(/[&<>'"]/g,x=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#039;','"':'&quot;'}[x]));
const money=c=>{try{return new Intl.NumberFormat(undefined,{style:'currency',currency:document.documentElement.dataset.currency||'INR',maximumFractionDigits:0}).format(Number(c||0)/100)}catch(_){return`₹${Math.round(Number(c||0)/100)}`}};
const toast=m=>{const e=$('[data-toast]');if(!e)return;e.textContent=m;e.classList.add('is-visible');clearTimeout(window.__sdpcToast);window.__sdpcToast=setTimeout(()=>e.classList.remove('is-visible'),2500)};
const overlayOpen=()=>Boolean($('[data-drawer-name].is-open,[data-modal].is-open,[data-product-lightbox].is-open'));
const lock=()=>document.body.classList.toggle('is-locked',overlayOpen());
const drawer=(el,open)=>{
  if(!el)return;
  if(open)el.hidden=false;
  el.classList.toggle('is-open',open);
  el.setAttribute('aria-hidden',String(!open));
  if(!open)setTimeout(()=>{if(!el.classList.contains('is-open'))el.hidden=true},340);
  lock();
};
const openDrawer=name=>{
  const el=$$('[data-drawer-name]').find(x=>x.dataset.drawerName===name);
  if(!el){if(name==='cart')location.assign(R.cartUrl||'/cart');return}
  $$('[data-drawer-name].is-open').filter(x=>x!==el).forEach(x=>drawer(x,false));
  drawer(el,true);
  const focusTarget=name==='search'?$('[data-predictive-input]',el):$('[data-drawer-close]',el);
  requestAnimationFrame(()=>focusTarget?.focus({preventScroll:true}));
};
window.SDPC={$,$$,R,esc,money,toast,lock,drawer,openDrawer};
})();
